module.exports = __webpack_public_path__ + "img/signpost.1156ebd5.svg";